import {useState, useEffect} from 'react';
import Sidebar from '../../components/AdminDashboard/Sidebar';
import TopBar from '../../components/AdminDashboard/TopBar';
import MetaData from '../../layouts/MetaData';
import { getHrLists, 
    getHrProfile, 
    getDoctors, 
    getTimeSummaryReportforCCMByDrHr, 
    changeBilledStatus 
  } from '../../actions/adminActions';
import {useSelector, useDispatch} from 'react-redux';
import Select from 'react-select';
import { Table, Form, ProgressBar } from 'react-bootstrap';
import { useAlert } from 'react-alert';
import { Link, useHistory } from 'react-router-dom';
import Loader from '../../layouts/Loader';
import { TIME_SUMMARY_REPORT_RESET } from '../../constants/adminConstants';
import doctorIcon from '../../assets/Images/doctorIcon.png';
import hrIcon from '../../assets/Images/network.png';
import ExportCCMSummaryReportToCSV from '../../components/ExportCCMSummaryReportToCSV';
import { formatClinicianName } from '../../utils/clinicianName';
import { useSortableTable, SortableTh, nameFromString } from '../../components/SortableTable';
import { formatDate, formatDob } from '../../utils/dateFormat';

const REPORT_SORT_COLUMNS = {
    emrId: { type: 'string', value: (r) => r?.emrId },
    name: { type: 'name', value: (r) => nameFromString(r?.patientName) },
    dob: { type: 'date', value: (r) => r?.DOB },
    month: { type: 'string', value: (r) => r?.Month },
    totalReadings: { type: 'number', value: (r) => r?.totalReadings },
    totalMinutes: { type: 'number', value: (r) => r?.totalMinutes },
};


const FinancialReportCCM = () => {

    const dispatch = useDispatch();
    const alert = useAlert();
    const history = useHistory();

    let totalCharges = [];
    let category = 'CCM';
    
    const {  error, hrs } = useSelector(state => state.hrslist);
    const {loading, timeSummaryReport} = useSelector(state => state.summaryReport);
    const tableSort = useSortableTable(timeSummaryReport, { id: 'admin.ccmFinancialReport', columns: REPORT_SORT_COLUMNS, defaultSort: { key: 'name', dir: 'asc' } });
    const { hrProfile } = useSelector(state => state.hrprofile);
    const { doctors } = useSelector(state => state.doctor);
    const [filterPatient, setFilterPatient] = useState(false);
    const {message, error: billedError } = useSelector(state => state.common);
    const [assignedDrId, setAssignedDrId] = useState("");


    const [month, setMonth] = useState('09');
    const [year, setYear] = useState('2023');
    const [hrId, sethrId] = useState("");
    const [reportBy, setReportBy] = useState('doctor');
    const [drId, setDRId] = useState('');

    let hrDoctorId = hrProfile?.assigned_doctor_id?._id;

    
    useEffect(() => {
        if(error){
            alert.error(error);
        }

        if(message){
          alert.success(message);
        }

        if(billedError){
          alert.error(billedError);
        }
    
        dispatch(getHrLists());
        dispatch(getDoctors(10, 1));

        dispatch({
          type: TIME_SUMMARY_REPORT_RESET
        })
        
    }, [dispatch, error, message, billedError]);

    const hrOptions = []
        hrs && hrs.filter(item => item?.consentRole === 'CCM' || item?.consentRole === 'Both').map((hr) => (
            hrOptions.push({ value: hr?._id, label: [hr?.lastname +" , ", hr?.firstname +" ", hr?.consentRole ].join(" "), doctorId: hr?.assigned_doctor_id?._id})
    ))

    const getHRProfile = (hr) => {
        sethrId(hr.value);
        setAssignedDrId(hr.doctorId);
        dispatch(getHrProfile(hr.value));

    }

    const generateFinanceReport = () => {
      if(!hrId && !drId) {
            alert.error('Please select Nurse or Doctor');
            return; 
          } else if(reportBy === 'doctor'){
            dispatch(getTimeSummaryReportforCCMByDrHr(drId, hrDoctorId, month, year, reportBy));    
          } else { 
            dispatch(getTimeSummaryReportforCCMByDrHr(assignedDrId, hrId, month, year, reportBy));    
          } 
      }

    const resetReport = () => {
        dispatch({
            type: TIME_SUMMARY_REPORT_RESET
        })
    }

    const billedStatus = (patientId) => {
      var confirmation = window.confirm(`Are you sure you to change status to billed ?`);
        if(confirmation){
          dispatch(changeBilledStatus(patientId, month, category));
          generateFinanceReport();
        }
      }
      



  return (
    <>
    <MetaData title="Financial Report CCM"/>
        <Sidebar />    

        <section className="home-section">
        {/* TopBar */}
        <TopBar />

        <div className="shadow-lg mb-5 mr-4 ml-4 rounded-card">
            <div className='searchArea p-3'>
            <div className="row-display">
                  <div className="col-md-8">
                    <h5 style={{color: '#0044ad'}}>
                      <i className='bx bxs-bar-chart-alt-2'></i> <b>&nbsp;Financial Report For CCM </b>
                    </h5>
                  </div>

                  <button className="btn btn-secondary btn-sm" onClick={() => history.goBack()}>
                    <i className='bx bx-arrow-back' ></i>
                  </button> &nbsp;
                  <Link to="/report/financialReport" className="link pt-2">RPM Financial Report</Link> &nbsp;
                  <Link to="/financialReport/history" className="link pt-2">View History</Link> &nbsp;
            </div>
            <hr />

            <p className="notes-header"><b>Note: </b> You can generate financial report of CCM by Provider and by Nurse.</p>


            <div className="row cardWrapper">    
                <div className={`cardButton ${reportBy === "doctor" ? "cardActive" : ""}`}
                onClick={() => setReportBy("doctor")}>
                    <img src={doctorIcon} alt="" height="60" width="60"/>
                        <p> By Provider </p>
                </div>
                
                
                <div className={`cardButton ${reportBy === "hr" ? "cardActive" : ""}`}
                onClick={() => setReportBy("hr")}>
                    <img src={hrIcon} alt="" height="60" width="60"/>
                    <p> By Nurse </p>
                </div>
            </div>

            {/* Select boxes */}
            <div className="row-display">
                  <div className="col-md-3">
                    {reportBy === 'doctor' ? <>
                    <b>Select Provider <span style={{color: 'red'}}> *</span>  </b>
                    <select 
                        className="form-control"
                        value={drId}
                        onChange={(e) => setDRId(e.target.value)}
                        >
                        <option>Select Provider</option>
                        {doctors && doctors.map((doctor, index) => (
                                <option value={doctor?._id} key={index}>{formatClinicianName(doctor)} {doctor?.npinumber} </option>
                            ))} 
                    </select> 
                    </> : <>
                    <b>Select Nurse  <span style={{color: 'red'}}> *</span></b>
                      <Select
                          options={hrOptions}
                          onChange={getHRProfile}
                          className="react-selectbox"
                      />
                    </>}
                    
                    </div>

                <div className="col-md-3 mt-4">
                    <select 
                      name="month" 
                      className="form-control"
                      value={month} 
                      onChange={e => setMonth(e.target.value)}
                      >
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                </div>

                <div className="col-md-3 mt-4">
                    <select 
                      name="month" 
                      className="form-control"
                      value={year} 
                      onChange={e => setYear(e.target.value)}
                      >
                      {(() => { const years = []; for (let y = 2022; y <= new Date().getFullYear() + 1; y++) years.push(y); return years; })().map((y) => (
                          <option key={y} value={y}>{y}</option>
                      ))}
                    </select>
                </div>

                <div className="col-md-3 mt-4">
                    <button className="edit-pill" onClick={generateFinanceReport}>Generate</button>
                </div>
              </div>
            </div>

            {loading ? <Loader /> : <>
              {timeSummaryReport && timeSummaryReport?.length > 0 ? <>

                <div className="row-display p-4">
                      <h5 className="title">Financial Report Preview</h5>

                      <div className="row-display">
                        <div className="pt-2 pr-3">
                            <Form.Check 
                              checked={filterPatient ? true : false}
                              onChange={() => setFilterPatient(!filterPatient)}
                              type="checkbox"
                              id="filterPts"
                              label="Minutes > 0 ?"
                              style={{fontWeight: 'bold'}}
                            />
                        </div>

                        <div className='row-display'>
                          <button className="edit-pill" onClick={resetReport}>
                            <i className='bx bxs-file-pdf'></i> Reset
                          </button> &nbsp;
                        
                        <div>
                            <ExportCCMSummaryReportToCSV 
                              filterPatient={filterPatient}
                              csvData={tableSort.rows} 
                              fileName={'CCM Financial Report'+ formatDate(new Date())+'.csv'}
                            />
                        </div>

                        </div>
                      </div>
                </div>

                {/* Report Result starts from here */}
                <div className="col-md-12">
                          <br />
                        <Table Striped bordered hover>
                            <thead align="center">
                                <tr>
                                  <th>Sr. No</th>
                                  <SortableTh sortKey="emrId" sort={tableSort}>EHR - ID</SortableTh>
                                  <SortableTh sortKey="name" sort={tableSort}>Patient Name</SortableTh>
                                  <SortableTh sortKey="dob" sort={tableSort}>D.O.B</SortableTh>
                                  <SortableTh sortKey="month" sort={tableSort}>Month</SortableTh>
                                  <SortableTh sortKey="totalMinutes" sort={tableSort}>Total Minutes</SortableTh>
                                  <th>Nurse Contribution</th>
                                  <th>CPT</th>
                                  <th>Payment</th>
                                  <th>Total</th>
                                  <th>Billed Status</th>
                                  <th>Action</th>
                                </tr>

                                {tableSort.rows.filter(item => filterPatient ? item.totalMinutes > 0 : item).map((summaryReport, index) => (
                                    <tr key={index}> 
                                      <td>{index + 1}</td>

                                      <td>{summaryReport?.emrId || 'N/A'}</td>

                                      <td>
                                        <Link className="link" 
                                        to={{ pathname: "/patientProfile", state: {patientid: summaryReport?.patientId }}}>
                                          {summaryReport?.patientName}
                                        </Link>
                                      </td>

                                      <td>
                                        {formatDob(summaryReport?.DOB)}
                                      </td>

                                      <td style={{wordWrap: 'break-word'}}>{summaryReport?.Month} - CCM</td>
                                      
                                      
                                      {/* Total Minutes */}
                                      <td><b>{summaryReport?.totalMinutes}</b></td>

                                      <td><b>{summaryReport?.nurseContributed} mins</b><p>
                                      <ProgressBar  
                                        animated 
                                        variant='primary' 
                                        now={((summaryReport?.nurseContributed / summaryReport?.totalMinutes) * 100).toFixed()} 
                                          />  
                                      </p></td>
                                      
                                      {/*  CPT Codes */}
                                      <td style={{color: 'green', fontWeight: 'bold'}}>
                                        {summaryReport?.totalMinutes >=20 && summaryReport?.totalMinutes < 40 ? '99490' : 
                                        summaryReport?.totalMinutes >= 40 && summaryReport?.totalMinutes < 60 ? '99490, 99439' : 
                                        summaryReport?.totalMinutes >= 60 && summaryReport?.totalMinutes < 80 ? '99487' : 
                                        summaryReport?.totalMinutes >= 80 && summaryReport?.totalMinutes < 90 ? '99489, 99439' :
                                        summaryReport?.totalMinutes >= 90 && summaryReport?.totalMinutes < 110 ? '99487, 99489' : 
                                        summaryReport?.totalMinutes >= 110 && summaryReport?.totalMinutes < 120 ? '99489, 99487, 99439' : 
                                        summaryReport?.totalMinutes >= 120 ? '99487, 99489, 99489' :
                                        null  
                                        }
                                      </td>


                                      {/* CPT codes payment  */}
                                      <td style={{color: 'green', fontWeight: 'bold'}}>
                                        {summaryReport?.totalMinutes >=20 && summaryReport?.totalMinutes < 40 ? '$49.73' : 
                                        summaryReport?.totalMinutes >= 40 && summaryReport?.totalMinutes < 60 ? '$49.73, $37.49' : 
                                        summaryReport?.totalMinutes >= 60 && summaryReport?.totalMinutes < 80 ? '$73.70' :
                                        summaryReport?.totalMinutes >= 80 && summaryReport?.totalMinutes < 90 ? '$35.70, $37.49' :
                                        summaryReport?.totalMinutes >= 90 && summaryReport?.totalMinutes < 110 ? '$35.70, $73.70' : 
                                        summaryReport?.totalMinutes >= 110 && summaryReport?.totalMinutes < 120 ? '$35.70, $73.70, $37.49' : 
                                        summaryReport?.totalMinutes >= 120 ? '$35.70, $73.70, $73.70' : null  
                                        }
                                      </td>

                                      {/* CPT Code total payment  */}
                                      <td style={{color: 'green', fontWeight: 'bold'}}>
                                        {summaryReport?.totalMinutes >=20 && summaryReport?.totalMinutes < 40 ? <>
                                          <p>$49.73 </p><b style={{display: 'none'}}>{totalCharges.push({charges: 49.73})}</b>
                                        </>: 
                                        summaryReport?.totalMinutes >= 40 && summaryReport?.totalMinutes < 60 ? <><p>$87.22</p> <b style={{display: 'none'}}>{totalCharges.push({charges: 87.22})}</b></> : 
                                        summaryReport?.totalMinutes >= 60 && summaryReport?.totalMinutes < 80 ? <><p>$73.70</p> <b style={{display: 'none'}}>{totalCharges.push({charges: 73.70})}</b></> : 
                                        summaryReport?.totalMinutes >= 80 && summaryReport?.totalMinutes < 90 ? <><p>$73.19</p> <b style={{display: 'none'}}>{totalCharges.push({charges: 73.19})}</b></> :
                                        summaryReport?.totalMinutes >= 90 && summaryReport?.totalMinutes < 110 ? <><p>109.40</p><b style={{display: 'none'}}>{totalCharges.push({charges: 109.40})}</b> </> : 
                                        summaryReport?.totalMinutes >= 110 && summaryReport?.totalMinutes < 120 ? <><p>$146.89</p><b style={{display: 'none'}}>{totalCharges.push({charges: 146.89})}</b></> :
                                        summaryReport?.totalMinutes >= 120 ? <><p>$183.10</p><b style={{display: 'none'}}>{totalCharges.push({charges: 183.10})}</b></>  
                                        : null  
                                        }
                                      </td>  

                                      {summaryReport?.totalMinutes >= 20 ? <>
                                        <td>{summaryReport?.billedStatus === true ? 
                                        <p className="m-0 p-0" style={{fontWeight: 'bold', color: 'green'}}>Billed</p> : 
                                          <p className="m-0 p-0" style={{fontWeight: 'bold', color: 'red'}}>Not Billed</p>}
                                        <p className="m-0 p-0"><small>Month of: {summaryReport?.Month}</small></p>
                                        </td>
                                      </> : <td> </td>
                                      }   

                                      {summaryReport?.totalMinutes >= 20 ? <>
                                      <td>
                                      {summaryReport?.billedStatus === true ? <> <i className='bx bx-check' style={{fontSize: '25px', color: 'green'}}></i> </>  
                                          : <> <button className="btn btn-outline-primary btn-sm"
                                          onClick={() => billedStatus(summaryReport?.patientId)}
                                          >Billed </button> </> }
                                      </td>
                                      </> : <td> </td>
                                      }
                                      
                                    </tr>
                                  ))}
                            </thead>
                        </Table>
                    </div>

                    <div style={{float: 'right'}} className="mr-4">
                            <b>Total Payment : </b> <h5>  <b style={{color: 'green'}}> $ {totalCharges.reduce((total, currentValue) => total = total + currentValue.charges,0).toFixed(2)} </b></h5>
                          </div>
                          <br/><br/><br/><br/>
              </> : null }
              </> }
              
              
          </div>
        </section>
        </>
  )
}

export default FinancialReportCCM;